/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Device_NoneInputs */

const en_ui_laps_device_none = /** @type {(inputs: Ui_Laps_Device_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No laps recorded`)
};

const de_ui_laps_device_none = /** @type {(inputs: Ui_Laps_Device_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Runden aufgezeichnet`)
};

/**
* | output |
* | --- |
* | "No laps recorded" |
*
* @param {Ui_Laps_Device_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_device_none = /** @type {((inputs?: Ui_Laps_Device_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Device_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_device_none(inputs)
	return de_ui_laps_device_none(inputs)
});